const BANNER_SCRIPT_URL = 'https://cdn.shopify.com/shopifycloud/privacy-banner/storefront-banner.js';

function getPrivacyConfig() {
  const configElement = document.getElementById('cookie-preferences-config');
  if (!configElement) return {};

  try {
    return JSON.parse(configElement.textContent);
  } catch {
    return {};
  }
}

function buildPrivacyOptions(config) {
  const options = {};
  const token = config.storefrontAccessToken || window.Shopify?.storefrontAccessToken;

  if (token) options.storefrontAccessToken = token;
  if (config.storefrontRootDomain) options.storefrontRootDomain = config.storefrontRootDomain;
  if (config.checkoutRootDomain) options.checkoutRootDomain = config.checkoutRootDomain;
  if (config.locale) options.locale = config.locale;
  if (config.country) options.country = config.country;

  return options;
}

function loadScript(src) {
  return new Promise((resolve, reject) => {
    const existing = document.querySelector(`script[src="${src}"]`);
    if (existing) {
      if (existing.dataset.loaded === 'true') {
        resolve();
        return;
      }

      existing.addEventListener('load', () => resolve(), { once: true });
      existing.addEventListener('error', () => reject(new Error(`Failed to load ${src}`)), { once: true });
      return;
    }

    const script = document.createElement('script');
    script.src = src;
    script.async = true;
    script.addEventListener(
      'load',
      () => {
        script.dataset.loaded = 'true';
        resolve();
      },
      { once: true }
    );
    script.addEventListener('error', () => reject(new Error(`Failed to load ${src}`)), { once: true });
    document.head.appendChild(script);
  });
}

function waitForPrivacyBanner(maxAttempts = 40, intervalMs = 150) {
  return new Promise((resolve, reject) => {
    let attempts = 0;

    const timer = setInterval(() => {
      attempts += 1;

      if (window.privacyBanner?.showPreferences) {
        clearInterval(timer);
        resolve(window.privacyBanner);
        return;
      }

      if (attempts >= maxAttempts) {
        clearInterval(timer);
        reject(new Error('privacyBanner not available'));
      }
    }, intervalMs);
  });
}

async function ensurePrivacyBanner() {
  if (window.privacyBanner?.showPreferences) {
    return window.privacyBanner;
  }

  try {
    return await waitForPrivacyBanner(15, 100);
  } catch {
    // Shopify may not initialize privacyBanner on live without preview_privacy_banner=1.
  }

  const config = getPrivacyConfig();

  if (config.storefrontAccessToken) {
    window.Shopify = window.Shopify || {};
    window.Shopify.storefrontAccessToken = config.storefrontAccessToken;
  }

  await loadScript(BANNER_SCRIPT_URL);

  let banner;
  try {
    banner = await waitForPrivacyBanner(20, 100);
  } catch {
    banner = null;
  }

  const options = buildPrivacyOptions(config);

  if (window.privacyBanner?.loadBanner) {
    await Promise.resolve(window.privacyBanner.loadBanner(options));
  } else if (!banner && Object.keys(options).length > 0) {
    await waitForPrivacyBanner(20, 100);
    if (window.privacyBanner?.loadBanner) {
      await Promise.resolve(window.privacyBanner.loadBanner(options));
    }
  }

  return waitForPrivacyBanner(30, 150);
}

async function openShopifyCookiePreferences(event) {
  if (event) {
    event.preventDefault();
    event.stopPropagation();
  }

  const config = getPrivacyConfig();
  const options = buildPrivacyOptions(config);

  try {
    const banner = await ensurePrivacyBanner();

    if (Object.keys(options).length > 0) {
      await Promise.resolve(banner.showPreferences(options));
    } else {
      await Promise.resolve(banner.showPreferences());
    }
  } catch {
    document.querySelector('.shopify-pc__banner__btn-manage-prefs')?.click();
  }
}

function initCookiePreferencesLinks() {
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-cookie-preferences], a[href="#cookie-preferences"]');
    if (!trigger) return;
    openShopifyCookiePreferences(event);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCookiePreferencesLinks);
} else {
  initCookiePreferencesLinks();
}
